import { ClientsClient, GetClient } from 'src/app/generated-client/generated-client';
import { AfterViewInit, Component, Input, OnDestroy, OnInit, ViewChild, inject, ChangeDetectionStrategy, signal } from '@angular/core';
import { debounceTime, takeUntil } from 'rxjs/operators';

import { MatPaginator } from '@angular/material/paginator';
import { MatSort, MatSortHeader } from '@angular/material/sort';
import { MatTableDataSource, MatTable, MatColumnDef, MatHeaderCellDef, MatHeaderCell, MatCellDef, MatCell, MatHeaderRowDef, MatHeaderRow, MatRowDef, MatRow } from '@angular/material/table';
import { PaginationResult } from 'ng-lightquery';
import { Subject } from 'rxjs';

@Component({
    selector: 'da-unassigned-client-table',
    templateUrl: './unassigned-client-table.component.html',
    styleUrl: './unassigned-client-table.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [MatTable, MatSort, MatColumnDef, MatHeaderCellDef, MatHeaderCell, MatSortHeader, MatCellDef, MatCell, MatHeaderRowDef, MatHeaderRow, MatRowDef, MatRow, MatPaginator]
})
export class UnassignedClientTableComponent implements OnInit, AfterViewInit, OnDestroy {
  private clientsClient = inject(ClientsClient);

  @Input() set filter(filterWord: string) {
    this.filterWord = filterWord;
    this.$filter.next();
  }
  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild(MatSort) sort: MatSort;
  dataUnassignedClients = new MatTableDataSource<GetClient>([]);
  private $filter = new Subject<void>();
  private $destroy = new Subject<boolean>();
  displayedColumns = ['id', 'name', 'customerName'];
  clientsOfCustomerPaginated = signal<PaginationResult<GetClient>>(null);
  filterWord: string;

  ngOnInit(): void {
    this.$filter.pipe(takeUntil(this.$destroy), debounceTime(250)).subscribe(() => this.applyFilter());
    this.initData();
  }

  ngAfterViewInit() {
    this.dataUnassignedClients.paginator = this.paginator;
    this.dataUnassignedClients.sort = this.sort;
  }

  ngOnDestroy(): void {
    this.$destroy.next(true);
    this.$destroy.complete();
  }

  initData(): void {
    this.clientsClient.getClients(null, null).subscribe({
      next: (list: GetClient[]) => {
        this.dataUnassignedClients.data = list.filter(item => !item.customerId);
        this.applyFilter();
      },
      error: err => {
        console.log(err);
      }
    });
  }

  applyFilter(): void {
    this.dataUnassignedClients.filter = this.filterWord.trim().toLowerCase();
  }
}
